import { AnsweringClient } from "../clients/answeringClient";

export interface DoutoradoSelectCollectionControllerDelegate {
  submitedSuccess(): void;
  genericError(message: string): void;
  applicationShouldLogout(): void;
}

export class DoutoradoSelectCollectionController {
  constructor(
    private delegate: DoutoradoSelectCollectionControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  async assignCollection(collectionCode: string) {
    const accessToken = localStorage.getItem("AccessToken");
    if (!accessToken) {
      this.delegate.applicationShouldLogout();
      return;
    }

    if (!collectionCode.trim()) {
      this.delegate.genericError("Por favor, insira o código da coleta.");
      return;
    }

    try {
      await this.answeringClient.assignDoutorado(collectionCode, accessToken);
      this.delegate.submitedSuccess();
    } catch (error: any) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        this.delegate.applicationShouldLogout();
      } else if (error?.response?.data?.message) {
        this.delegate.genericError(error.response.data.message);
      } else {
        this.delegate.genericError(
          "Ocorreu um erro desconhecido. Verifique o código e tente novamente."
        );
      }
    }
  }
}
